import { type FC, type PropsWithChildren, useCallback, useMemo, useRef } from "react";
import { useFormContext } from "react-hook-form";

import { type GridData, GridFormContext, type GridFormValues } from "./use-grid-form";

export const GridFormProvider: FC<PropsWithChildren<{ data: GridData }>> = ({ children, data }) => {
  const formContext = useFormContext<GridFormValues>();

  const selectedRowIds = formContext.watch("rowIds");
  const hasSelection = selectedRowIds.length > 0;

  const clearSelection = useCallback(() => formContext.setValue("rowIds", []), [formContext]);

  const lastClickedIdRef = useRef<string | null>(null);

  const getLastClickedRowId = useCallback(() => lastClickedIdRef.current, []);
  const setLastClickedRowId = useCallback((id: string | null) => (lastClickedIdRef.current = id), []);

  const contextValue = useMemo(
    () => ({
      formContext,
      getLastClickedRowId,
      setLastClickedRowId,
      data,
      selectedRowIds,
      hasSelection,
      clearSelection,
    }),
    [formContext, getLastClickedRowId, setLastClickedRowId, data, selectedRowIds, hasSelection, clearSelection]
  );

  return <GridFormContext.Provider value={contextValue}>{children}</GridFormContext.Provider>;
};
